import type { ReactNode } from 'react';
import { MsalProvider } from '@azure/msal-react';
import {
  EventType,
  type PublicClientApplication,
  type EventMessage,
  type AuthenticationResult,
} from '@azure/msal-browser';

interface AuthProviderProps {
  msalInstance: PublicClientApplication;
  children: ReactNode;
}

/**
 * Thin wrapper around MsalProvider that sets the active account
 * after a successful login event.
 */
export default function AuthProvider({ msalInstance, children }: AuthProviderProps) {
  // Set active account on login success so subsequent token calls use it
  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const result = event.payload as AuthenticationResult;
      msalInstance.setActiveAccount(result.account);
    }
  });

  return <MsalProvider instance={msalInstance}>{children}</MsalProvider>;
}
